/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from '@store/getters.constants';

const getters = {
  [storeGetters.getVsmMetricList]: (state) => {
    return state.vsmList;
  },
  [storeGetters.getVsmsList]: (state) => {
    return state.vsms;
  },
  // [storeGetters.getLicenseByid]: (state) => {
  //   return state.license;
  // },
  // [storeGetters.getLicenseCount]: (state) => {
  //   return state.licenseCount;
  // },
};
export default { ...getters };